import Cotizar from './components/cotizar';
import BeneficiosCondiciones from './components/beneficiosCondiciones';
/******************** BUILD ********************/
import less from "../index.less";
/******************** BUILD ********************/
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      configurations: {},
      popovers: {},
      startShoppingProperties: {}
    }

    this.loginUrl = '';
  }

  componentDidMount() {
    const configurations = { ...this.state.configurations };
    const popovers = {};
    const pnpService = new ServicioPnp();
    pnpService.getListWithTop('configuraciones', (list) => {
      configurations['ErrorServicio'] = list[0] ? list[0].CSValorNote : 'Discúlpenos, por favor intente más tarde';

      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote;
      });

      this.setState({ configurations: configurations }, () => {
      })
    }, 400, null, 'CSNombreText', 'CSValorNote');

    pnpService.getListWithTop('parametrosPaginas', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote == 'false' ? false : item.CSValorNote;
        configurations[item.CSNombreText + 'CSVisibleBool'] = item.CSVisibleBool;

        (item.CSNombreText == "MensajeValidacionAutogestionSimulador" || item.CSNombreText == "MensajeValidacionAutenticadoSimulador" || item.CSNombreText == 'MensajeValidacionCalendarioSimulador') ? popovers[item.CSNombreText] = item.CSValorNote : null

      });
      this.setState({ configurations: configurations });
    }, 400, "CSFormularioChoice eq 'Simulaci%C3%B3n'", 'CSDescripcionNote', 'CSFormularioChoice', 'CSNombreText', 'CSValorNote', 'CSVisibleBool');

    pnpService.getList('popovers', (list) => {
      list.forEach((item) => {
        popovers[item.CSIDPopOverText] = {
          position: item.CSPosicionPopOverChoice,
          buttonText: item.CSTextoBotonText,
          title: item.CSTituloPopOverText,
          description: item.CSTextoAyudaNote.split('\n').join('<br />')
        };
      });
      this.setState({ popovers: popovers });
    }, null, 'CSCampoFormNote', 'CSIDPopOverText', 'CSPosicionPopOverChoice', 'CSTextoAyudaNote', 'CSTextoBotonText', 'CSTituloPopOverText');

    setTimeout(() => {
      this.isAuthenticated(configurations)
    }, 500);

  }

  callMainService(tipoIdentificacion, indentificacion) {

    const startShoppingProperties = { ...this.state.startShoppingProperties };

    const url = 'ValidarVisualizacionInicioCompraVentaVinculacion?tipoDocumento=' + tipoIdentificacion + '&numeroDocumento=' + indentificacion;
    const validarVisualizacionInicioCompraVentaVinculacion = new ServicioProxy(url, 'ServicioConsorcio.svc');
    validarVisualizacionInicioCompraVentaVinculacion.getElements('POST', {}).then((response) => {
      const data = JSON.parse(response);

      /*data = {
        "Error": null,
        "Autenticado": true,
        "PuedeIniciarAutogestion": true,
        "PuedeIniciarCalendario": true
      }*/

      startShoppingProperties['AutenticadoValue'] = indentificacion != 0 ? true : false;
      startShoppingProperties['PuedeIniciarAutogestionValue'] = data.PuedeIniciarAutogestion;
      startShoppingProperties['PuedeIniciarCalendarioValue'] = data.PuedeIniciarCalendario;
      //startShoppingProperties['PuedeIniciarCalendarioValue'] = true;

      this.setState({ startShoppingProperties }, () => { console.log('startShoppingProperties ==> ', this.state.startShoppingProperties['PuedeIniciarCalendarioValue']) });
    }).catch(error => {
      //this.setState({ });
    });
  }

  isAuthenticated() {


    if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
      const userInfo = compTools.obtenerInformacionUsuario();
      this.callMainService(userInfo.TipoIdentificacion, userInfo.LegalID);
    } else {
      this.callMainService(0, 0);
    }
  }

  render() {
    return (
      <div>
        <div className="text-right">
          {this.state.configurations['CompensarSaludPlanComplementario'] &&
            <img src={_spPageContextInfo.siteAbsoluteUrl + '/Style Library/Images/' + this.state.configurations['CompensarSaludPlanComplementario']} />
          }
        </div>
        <div id="simulation-container">
          <Cotizar configurations={this.state.configurations} popovers={this.state.popovers} startShoppingProperties={this.state.startShoppingProperties} />
          <BeneficiosCondiciones id="beneficiosCondicionesID" className="beneficiosCondiciones" configurations={this.state.configurations} />
        </div>
      </div>
    );
  }
}

/******************** BUILD ********************/
const appId = document.getElementById('app');
ReactDOM.render(<App />, appId);
/******************** BUILD ********************/

/******************** TEST ********************/
//export default App;
/******************** TEST ********************/